<template>
    <control-panel
        :breadcrumbs="breadcrumbsItems"
    >
        <span>{{ dataGatheringInfo.title }}</span>

        <template #right>
            <data-records-filters>
                <template #append>
                    <!-- space between buttons -->

                    <likert-dialog v-model="dialogs.likert"/>

                    <div class="ml-md-5 ml-lg-5 ml-sm-2 ml-0 mb-2">
                        <v-btn
                            v-if="checkPermission('DATA_SOURCES_DATA_RECORDS_GENERATE')"
                            :disabled="disabled"
                            class="v-btn--primary"
                            @click="downloadDataGathering"
                        >
                            <v-icon
                                class="mr-2"
                                v-if="isQueue"
                            >mdi-sort-clock-ascending
                            </v-icon>
                            <v-icon
                                class="mr-2"
                                v-else
                            >mdi-cloud-download
                            </v-icon>
                            {{ downloadStatus }}
                            <v-progress-circular
                                indeterminate
                                class="mt-20 ml-2"
                                v-if="showProgress"
                                color="grey"
                                size="16"
                            ></v-progress-circular>
                        </v-btn>
                    </div>

                    <replace-form-dialog
                        v-model="dialogs.replace"
                        :data-gathering="dataGathering"
                        @confirm="onConfirmAction"
                    />

                    <!-- download action -->

                    <div class="ml-md-5 ml-lg-5 ml-sm-2 ml-0 mb-2">
                        <v-btn
                            class="v-btn--red"
                            v-if="emptyRecords && checkPermission('DATA_SOURCES_DATA_RECORDS_DELETE_EMPTY')"
                            @click="showDelete"
                        >
                            {{ $t('app.delete') }}
                        </v-btn>
                    </div>

                    <delete-dialog
                        v-model="show_delete"
                        @confirm="onConfirmAction"
                        :data-gathering="dataGathering"
                    />

                    <v-menu v-if="showMoreOptions" left offset-y rounded="0">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on">
                                <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                        </template>
                        <v-list class="list">
                            <v-list-item
                                v-for="(item, index) in filteredListItem"
                                v-if="showItem(item.action)"
                                :disabled="item.disabled(status, dataGathering)"
                                :key="index"
                                @click="onSelectedMenuItem(item.action)"
                                :class="item.class ? 'list--item ' + item.class : 'list--item'"
                                link
                                dense
                            >
                                <v-list-item-icon>
                                    <v-icon>{{ item.icon }}</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-menu>

                    <v-dialog
                        v-model="dialogs.show_add"
                        persistent
                        max-width="658px"
                        scrollable
                        content-class="bible-form-dialog"

                    >
                        <data-record-add-form @confirm="onConfirmAction" @cancel="onCancelAddDataRecord"
                        />

                    </v-dialog>

                    <v-dialog
                        v-model="dialogs.show_custom"
                        persistent
                        max-width="724px"
                        content-class="bible-form-dialog"
                        max-height="658px"
                    >
                        <data-record-custom-column @close="onCloseCustomColumn"/>

                    </v-dialog>

                </template>
            </data-records-filters>
        </template>
    </control-panel>
</template>

<script>
import _ from "lodash";
import DataRecordsFilters from "@/Shared/DathaGatherings/Common/Records/DataRecordsFilters";
import ControlPanel from "@/Shared/ControlPanel";
import {mapActions, mapState} from "pinia";
import {DataRecordsStore} from "@/Store/DataGatherings/DataRecordsStore";
import ReplaceFormDialog from "@/Shared/DathaGatherings/Common/Forms/ReplaceDialog.vue";
import LikertDialog from "@/Shared/Dialogs/LikertDialog";
import DeleteDialog from "@/Shared/DathaGatherings/Common/Forms/DeleteDialog";
import DataRecordAddForm from "./DataRecordAddForm.vue";
import toastMixin from "@/Shared/toastMixin";
import {i18n} from "@/i18n";
import {bibleResumeAbbr} from "@/Repositories/DataGathering/DataGatheringRepository";
import DataRecordCustomColumn from "@/Shared/DathaGatherings/Common/Records/DataRecordCustomColumn";
import {PermissionsStore} from "@/Store/PermissionsStore";

export default {
    components: {LikertDialog, ReplaceFormDialog, ControlPanel, DataRecordsFilters, DeleteDialog, DataRecordAddForm, DataRecordCustomColumn},

    props: {
        breadcrumbsItems: {
            type: Array,
            require: true,
        },
        emptyRecords: {
            type: Boolean,
            default: false,
        },
        generated:{
            type: Boolean,
            default: false,
        },
    },

    mixins: [toastMixin],

    data: () => ({
        currentSection: window.location.pathname,
        dialogs: {
            likert: false,
            replace: false,
            show_add: false,
            show_custom: false,
        },
        show_delete: false,
        downloadStatus: '',
        intervalId: null,
        disabled: true,
        showProgress: false,
        isQueue: false,
        menuItems: [
            {
                display: true,
                disabled: (status, dataGathering) => status === 'closed' || bibleResumeAbbr.inArray(dataGathering.type.abbr),
                title: i18n.tc('data_gatherings.replace'),
                icon: "mdi-file-replace",
                action: 'showReplace'
            },
            {
                display: window.location.pathname.includes('surveys'),
                disabled: (status, dataGathering)=> false,
                title: "Likert",
                icon:'mdi mdi-ruler' ,
                action: 'showLikert'
            },
            {
                display: true,
                disabled: (status, dataGathering)=> status === 'closed' || bibleResumeAbbr.inArray(dataGathering.type.abbr),
                title: "Añadir",
                icon: "mdi mdi-plus",
                action: 'showAddDialog'
            },
            {
                display: window.location.pathname.includes('bibles'),
                disabled: (status, dataGathering)=> false,
                title: "Personalizar",
                icon: "mdi mdi-view-column-outline",
                action: 'showCustomDialog'
            },
        ],
    }),

    methods: {
        onConfirmAction() {
            const routes = {
                bible: 'bibles.index',
                surveys: 'surveys.index',
                abandonment: 'abandonment.index',
                finished: 'finished.index',
            };

            for (const key in routes) {
                if (this.currentSection.includes(key)) {
                    this.$inertia.get(route(routes[key]));
                    break;
                }
            }
        },

        showDelete() {
            this.show_delete = true;
        },

        /**
         * Start to download in base to response status download
         * CREATED, IN_PROCESS, GENERATED.
         *
         * Re-start the generation of excel in case:
         * DEPRECATED.
         *
         * Failed in download status:
         * FAILED.
         *
         * @returns {Promise<string>}
         */
        async downloadDataGathering() {
            try {
                const response = await this.fetchStatusDownload(this.dataGathering);
                const { data } = response;

                const statusActions = {
                    'error': async () => {
                        this.disabled = false;
                        await this.generate(this.dataGathering);
                        this.downloadStatus = this.$t('data_records.generating');
                        this.disabled = true;
                        this.showProgress = true;
                    },
                    'DEPRECATED': async () => {
                        this.disabled = false;
                        await this.generate(this.dataGathering);
                    },
                    'FAILED': async () => {
                        this.disabled = false;
                        await this.generate(this.dataGathering);
                    },
                    'CREATED': async () => {
                        this.disabled = true;
                        this.isQueue = true;
                        this.$t('data_records.waiting');
                        await this.generate(this.dataGathering);
                    },
                    'GENERATED': async () => {
                        this.disabled = false;
                        this.downloadStatus = this.$t('data_records.download');
                        const downloadResponse = await this.download(response);
                        this.handleFileDownload(downloadResponse);
                        this.toast().success(
                            this.$t('data_records.success_download_message'),
                        );
                    }
                };

                const defaultAction = async () => {
                    this.disabled = true;
                };

                const action = data.error ? 'error' : data.status;

                await (statusActions[action] || defaultAction)();

                await this.statusDownload();

            } catch (ex) {
                this.toast().error(
                    this.$t('data_records.error_download_message'),
                );
            }
        },

        /**
         * Management the request from convert a blob object
         * to download file in client
         *
         * @param downloadResponse
         */
        handleFileDownload(downloadResponse) {
            try {
                const url = window.URL.createObjectURL(downloadResponse.data);

                const contentDisposition = downloadResponse.headers['content-disposition'];
                const fileNameMatch = contentDisposition?.match(/filename="(.+)"/);
                const fileName = fileNameMatch ? fileNameMatch[1] : 'file.xlsx';

                const link = document.createElement('a');
                link.href = url;
                link.download = decodeURIComponent(fileName);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                window.URL.revokeObjectURL(url);
            } catch (error) {
                this.toast().error(
                    this.$t('data_records.error_download_message'),
                );
            }
        },

        /**
         * Check status download of data-gathering
         *
         * @returns {Promise<void>}
         */
        async statusDownload() {
            try {
                const response = await this.fetchStatusDownload(this.dataGathering);
                const { data } = response;

                const statusMap = {
                    'IN_PROCESS': {
                        downloadStatus: this.$t('data_records.generating'),
                        disabled: true,
                        showProgress: true,
                        isQueue: false,
                    },
                    'DEPRECATED': {
                        downloadStatus: this.$t('data_records.generate'),
                        disabled: false,
                        showProgress: false,
                        isQueue: false,
                    },
                    'FAILED': {
                        downloadStatus: this.$t('data_records.generate'),
                        disabled: false,
                        showProgress: false,
                        isQueue: false,
                    },
                    'CREATED': {
                        downloadStatus: this.$t('data_records.waiting'),
                        disabled: true,
                        showProgress: true,
                        isQueue: true,
                    },
                    'GENERATED': {
                        downloadStatus: this.$t('data_records.download'),
                        disabled: false,
                        showProgress: false,
                        isQueue: false,
                    }
                };

                if (data.error || statusMap[data.status]) {
                    const statusAction = statusMap[data.status] || statusMap['FAILED'];
                    this.downloadStatus = statusAction.downloadStatus;
                    this.disabled = statusAction.disabled;
                    this.showProgress = statusAction.showProgress;
                    this.isQueue = statusAction.isQueue;
                }
            } catch (ex) {
                this.toast().error(
                    this.$t('data_records.error_download_message'),
                );
            }
        },

        // Request to status download each 10 second
        startDownloadStatusCheck() {
            if (this.intervalId) {
                this.stopDownloadStatusCheck();
            }

            this.intervalId = setInterval(this.statusDownload, 10000); // 10 sec
        },

        // Stop interval to check status download
        stopDownloadStatusCheck() {
            if (this.intervalId) {
                clearInterval(this.intervalId);
                this.intervalId = null;
            }
            this.downloadStatus = null;
        },

        ...mapActions(DataRecordsStore, [
            'fetchStatusDownload',
            'generate',
            'download',
        ]),

        onSelectedMenuItem(action) {
            this[action](...arguments);
        },

        showReplace() {
            this.dialogs.replace = true;
        },

        showLikert() {
            this.dialogs.likert = true;
        },

        showAddDialog() {
            this.dialogs.show_add = true;
        },

        onCancelAddDataRecord() {
            this.hideAddDataForm();
        },

        hideAddDataForm() {
            this.dialogs.show_add = false;
        },

        showCustomDialog() {
            this.dialogs.show_custom = true;
        },

        onCloseCustomColumn() {
            this.dialogs.show_custom = false;
        },

        showItem(action) {
            switch (action) {
                case 'showAddDialog':
                    return this.checkPermission('DATA_SOURCES_DATA_RECORDS_ADD');
                case 'showReplace':
                    return this.checkPermission('DATA_SOURCES_DATA_RECORDS_REPLACE');
                case 'showCustomDialog':
                    return this.checkPermission('DATA_SOURCES_DATA_RECORDS_CUSTOMIZE');
                case 'showLikert':
                    return true;
            }
        },

        ...mapActions(PermissionsStore, ['checkPermission']),
    },

    computed: {
        dataGatheringInfo() {
            return {
                id: _.get(this, 'dataGathering.id'),
                title: _.get(this, 'dataGathering.title'),
            };
        },

        filteredListItem() {
           return this.menuItems.filter((item) => item.display === true)
        },

        ...mapState(DataRecordsStore, [
            'dataGathering',
            'status',
            'columns'
        ]),

        showMoreOptions() {
            return this.checkPermission('DATA_SOURCES_DATA_RECORDS_ADD') || this.checkPermission('DATA_SOURCES_DATA_RECORDS_REPLACE') || this.checkPermission('DATA_SOURCES_DATA_RECORDS_CUSTOMIZE');
        },
    },

    watch: {
        // Event generated from data-records-table component
        generated: {
            handler(newVal) {
                if (newVal) {
                    this.downloadStatus = this.$t('data_records.loading');
                    this.disabled = newVal;
                    this.$emit('resetGenerated');
                }
            },
            immediate: true,
            deep: true,
        },

        // Wait for changes to dataGathering object
        dataGathering: {
            handler(newVal) {
                if (newVal && Object.keys(newVal).length > 0) {
                    this.statusDownload();
                    this.startDownloadStatusCheck();
                }
            },
            immediate: true,
        },
    },

    // Clean setInterval before out of view client
    beforeDestroy() {
        this.stopDownloadStatusCheck();
    },
};
</script>

<style scoped lang="scss">
.list .v-list-item__title{
    text-transform: uppercase;
}
.bible-form-dialog .bible-form {
    height: auto;
}
</style>
